let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/**
 * Função para ocultar produtos sem estoque
 */
function hideOutOfStockProducts() {
  console.log('🔍 Iniciando ocultação de produtos sem estoque...');
  
  // Inicializar array global para salvar elementos removidos
  if (!window.hiddenOutOfStockElements) {
    window.hiddenOutOfStockElements = [];
  }
  
  let hiddenCount = 0;
  
  // Primeiro, buscar por produtos com classes sold-out e garantir que pegamos o card pai
  const soldOutElements = document.querySelectorAll('.sold-out, .out-of-stock, .unavailable');
  
  soldOutElements.forEach(element => {
    // Encontrar o card pai do produto - collection__grid__item como MÁXIMA prioridade
    const productCard = element.closest('.collection__grid__item, .card__container, .shoppable-product-card, .product-item, .product-card, .grid__item, .card, .product, .collection-list__item, .product-recommendation, [class*="product"], [class*="card"]');
    
    if (productCard && !productCard.hasAttribute('data-hidden-out-of-stock')) {
      // Salvar referência do elemento e sua posição original
      const elementData = {
        element: productCard,
        parent: productCard.parentNode,
        position: Array.from(productCard.parentNode.children).indexOf(productCard)
      };
      
      window.hiddenOutOfStockElements.push(elementData);
      
      productCard.setAttribute('data-hidden-out-of-stock', 'true');
      productCard.remove(); // Remove completamente do DOM
      hiddenCount++;
    }
  });
  
  // Buscar por produtos com atributos data indicando falta de estoque
  const dataSelectors = [
    '[data-available="false"]',
    '[data-sold-out="true"]',
    '[data-stock="0"]',
    '[data-inventory="0"]'
  ];
  
  dataSelectors.forEach(selector => {
    try {
      const products = document.querySelectorAll(selector);
      products.forEach(product => {
        // Se o elemento não é um card, buscar o card pai - collection__grid__item como MÁXIMA prioridade
        let productCard = product;
        if (!product.classList.contains('collection__grid__item') &&
            !product.classList.contains('card__container') &&
            !product.classList.contains('shoppable-product-card') &&
            !product.classList.contains('product-item') && 
            !product.classList.contains('product-card') && 
            !product.classList.contains('grid__item') &&
            !product.classList.contains('card')) {
          productCard = product.closest('.collection__grid__item, .card__container, .shoppable-product-card, .product-item, .product-card, .grid__item, .card, .product, .collection-list__item, [class*="product"], [class*="card"]');
        }
        
        if (productCard && !productCard.hasAttribute('data-hidden-out-of-stock')) {
          // Salvar referência do elemento e sua posição original
          const elementData = {
            element: productCard,
            parent: productCard.parentNode,
            position: Array.from(productCard.parentNode.children).indexOf(productCard)
          };
          
          window.hiddenOutOfStockElements.push(elementData);
          
          productCard.setAttribute('data-hidden-out-of-stock', 'true');
          productCard.remove(); // Remove completamente do DOM
          hiddenCount++;
        }
      });
    } catch (error) {
      console.warn(`Erro ao processar seletor ${selector}:`, error);
    }
  });
  
  // Buscar por produtos com texto indicando falta de estoque
  const textIndicators = [
    'esgotado', 
    'sem estoque', 
    'sold out', 
    'indisponível', 
    'fora de estoque',
    'out of stock',
    'unavailable',
    'não disponível',
    'produto esgotado'
  ];
  
  // Seletores para cards de produtos (containers principais) - collection__grid__item como MÁXIMA prioridade
  const productCardSelectors = [
    '.collection__grid__item',  // CLASSE PRINCIPAL DA GRADE DE COLEÇÃO - PRIORIDADE MÁXIMA
    '.card__container',        // CLASSE ESPECÍFICA SOLICITADA
    '.shoppable-product-card',  // CLASSE PRINCIPAL DO TEMA
    '.product-item', 
    '.product-card', 
    '.grid__item', 
    '.product',
    '.card',
    '.collection-list__item',
    '.product-recommendation',
    '[class*="product-"]',
    '[class*="card-"]'
  ];
  
  productCardSelectors.forEach(selector => {
    const products = document.querySelectorAll(selector);
    products.forEach(product => {
      if (product.hasAttribute('data-hidden-out-of-stock')) return;
      
      // Log específico para elementos collection__grid__item
      if (product.classList.contains('collection__grid__item')) {
        console.log('🎯 Processando collection__grid__item:', product.classList.toString());
      }
      
      const productText = product.textContent.toLowerCase();
      const hasOutOfStockText = textIndicators.some(indicator => 
        productText.includes(indicator)
      );
      
      // Verificar também botões desabilitados - incluindo o botão específico do tema
      const addToCartButton = product.querySelector('.shoppable-product-card__add-button, button[name="add"], .btn-product-add, .product-form__cart-submit, [data-add-to-cart], button[type="submit"]');
      const isButtonDisabled = addToCartButton && (addToCartButton.disabled || addToCartButton.hasAttribute('disabled'));
      
      // Verificar badges de sold out
      const hasSoldOutBadge = product.querySelector('.badge--sold-out, .sold-out-badge, .out-of-stock-badge, .badge.sold-out');
      
      // Verificação específica para elementos com scroll-trigger e animate--slide-in
      const hasAnimationClasses = product.classList.contains('scroll-trigger') || product.classList.contains('animate--slide-in');
      
      // if ((hasOutOfStockText || isButtonDisabled || hasSoldOutBadge) && !product.hasAttribute('data-hidden-out-of-stock')) {
      //   // Log específico quando removendo collection__grid__item
      //   if (product.classList.contains('collection__grid__item')) {
      //     console.log('🗑️ REMOVENDO collection__grid__item sem estoque:', {
      //       classes: product.classList.toString(),
      //       hasAnimationClasses: hasAnimationClasses,
      //       reason: hasOutOfStockText ? 'texto' : isButtonDisabled ? 'botão desabilitado' : 'badge sold-out'
      //     });
      //   }
        
      //   // Salvar referência do elemento e sua posição original
      //   const elementData = {
      //     element: product,
      //     parent: product.parentNode,
      //     position: Array.from(product.parentNode.children).indexOf(product)
      //   };
        
      //   window.hiddenOutOfStockElements.push(elementData);
        
      //   product.setAttribute('data-hidden-out-of-stock', 'true');
      //   product.remove(); // Remove completamente do DOM
      //   hiddenCount++;
      // }
    });
  });
  
  console.log(`✅ ${hiddenCount} produtos sem estoque foram ocultados`);
  
  return hiddenCount;
}

/**
 * Função para mostrar produtos sem estoque (reverter ocultação)
 */
function showOutOfStockProducts() {
  console.log('👁️ Mostrando produtos sem estoque...');
  
  // Buscar elementos removidos que foram salvos em uma variável global
  if (window.hiddenOutOfStockElements) {
    let shownCount = 0;
    
    window.hiddenOutOfStockElements.forEach(elementData => {
      if (elementData.element && elementData.parent) {
        // Restaurar o elemento na posição original
        if (elementData.position >= elementData.parent.children.length) {
          elementData.parent.appendChild(elementData.element);
        } else {
          elementData.parent.insertBefore(elementData.element, elementData.parent.children[elementData.position]);
        }
        
        elementData.element.removeAttribute('data-hidden-out-of-stock');
        shownCount++;
      }
    });
    
    // Limpar a lista de elementos ocultos
    window.hiddenOutOfStockElements = [];
    
    console.log(`✅ ${shownCount} produtos foram exibidos novamente`);
    return shownCount;
  }
  
  return 0;
}

/**
 * Função para alternar visibilidade de produtos sem estoque
 */
function toggleOutOfStockProducts() {
  const hiddenProducts = document.querySelectorAll('[data-hidden-out-of-stock="true"]');
  
  if (hiddenProducts.length > 0) {
    return showOutOfStockProducts();
  } else {
    return hideOutOfStockProducts();
  }
}

/**
 * Verificar se estamos em uma página de coleção (não em página de produto individual)
 */
function isCollectionPage() {
  // Detectar páginas de produtos com seletores mais específicos e abrangentes
  const isProductPage = document.querySelector('.main-product, .product-single, .product-form, .product-page, .product-template, .product-details, .product-main, .product-info, .product-content, .product-wrapper, .product-section, [data-section-type="product"], .template-product, body.template-product, html[class*="product"], body[class*="product"]');
  
  // Detectar páginas de coleção com seletores mais específicos
  const collectionElements = document.querySelector('.main-collection-product-grid, .collection__grid__item, .collection-list, .collection-grid, .product-grid, .products-grid, [data-section-type="collection"], .template-collection, body.template-collection');
  
  // Verificar URL para maior segurança
  const url = window.location.pathname.toLowerCase();
  const isProductUrl = url.includes('/products/') || url.match(/\/product\//);
  const isCollectionUrl = url.includes('/collections/') || url.match(/\/collection\//);
  
  // Log detalhado para debug
  console.log('🔍 Detecção de página - DEBUG COMPLETO:', {
    url: window.location.pathname,
    isProductPage: !!isProductPage,
    isProductUrl: isProductUrl,
    hasCollectionElements: !!collectionElements,
    isCollectionUrl: isCollectionUrl,
    bodyClass: document.body.className,
    htmlClass: document.documentElement.className,
    productPageElement: isProductPage ? isProductPage.className : null,
    collectionElement: collectionElements ? collectionElements.className : null
  });
  
  // Lógica mais restritiva: 
  // 1. NÃO pode ser página de produto (nem por elemento nem por URL)
  // 2. DEVE ter elementos de coleção OU URL de coleção
  // 3. Priorizar detecção de produto (se detectar produto, sempre retornar false)
  if (isProductPage || isProductUrl) {
    console.log('❌ BLOQUEADO: Página de produto detectada');
    return false;
  }
  
  if (collectionElements || isCollectionUrl) {
    console.log('✅ PERMITIDO: Página de coleção detectada');
    return true;
  }
  
  console.log('❓ BLOQUEADO: Tipo de página não identificado - por segurança, não executar');
  return false;
}

/**
 * Inicializar automaticamente quando a página carregar (apenas em páginas de coleção)
 */
document.addEventListener('DOMContentLoaded', function() {
  // Aguardar um pouco para garantir que todos os elementos foram carregados
  setTimeout(() => {
    if (isCollectionPage()) {
      console.log('🏪 Página de coleção detectada - executando hideOutOfStockProducts');
      hideOutOfStockProducts();
    } else {
      console.log('📄 Página de produto individual detectada - NÃO executando hideOutOfStockProducts');
    }
  }, 500);
});

// Também executar quando houver mudanças dinâmicas no conteúdo (apenas em páginas de coleção)
if (window.MutationObserver) {
  const observer = new MutationObserver(debounce(() => {
    // Só executar se não estivermos já processando E se estivermos em uma página de coleção
    if (!document.body.hasAttribute('data-processing-stock') && isCollectionPage()) {
      console.log('🔄 MutationObserver: Mudanças detectadas em página de coleção - executando hideOutOfStockProducts');
      document.body.setAttribute('data-processing-stock', 'true');
      hideOutOfStockProducts();
      setTimeout(() => {
        document.body.removeAttribute('data-processing-stock');
      }, 100);
    } else if (!isCollectionPage()) {
      console.log('🔄 MutationObserver: Mudanças detectadas mas NÃO é página de coleção - ignorando');
    }
  }, 1000));
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Executar também quando produtos são carregados via AJAX (apenas em páginas de coleção)
document.addEventListener('shopify:section:load', function() {
  setTimeout(() => {
    if (isCollectionPage()) {
      console.log('🔄 shopify:section:load: Seção carregada em página de coleção - executando hideOutOfStockProducts');
      hideOutOfStockProducts();
    } else {
      console.log('🔄 shopify:section:load: Seção carregada mas NÃO é página de coleção - ignorando');
    }
  }, 200);
});

// Disponibilizar as funções globalmente
window.hideOutOfStockProducts = hideOutOfStockProducts;
window.showOutOfStockProducts = showOutOfStockProducts;
window.toggleOutOfStockProducts = toggleOutOfStockProducts;
